import LivingEntity from "./LivingEntity";
export default class AntRobot extends LivingEntity {
  constructor(x, y, id, world) {
    super(x, y, id, world);

    // Specific entity params
  }
  onInteract(other) {
    console.log('Interacted')
  }

  onOtherEntityCollision(other){
    console.log('Collided with', other)
    
  }
  move() {
    super.move();

    // This is asuming it moved but if not, it will be at the same position
  }
}
